import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-3 row" }
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick", "aria-label"]
const _hoisted_13 = ["href", "aria-label"]
const _hoisted_14 = ["onClick", "aria-label"]
const _hoisted_15 = ["onClick", "aria-label"]
const _hoisted_16 = ["onClick", "aria-label"]
const _hoisted_17 = ["onClick", "aria-label"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = ["onClick", "aria-label"]

import {BTableColumn} from "../BTable/BTable.types";

import {FormModal} from "../Misc";
import AuditJobs from "./AuditJobs.vue";
import BGrid from "../BGrid/BGrid.vue";
import {onMounted, reactive, ref, computed} from "vue";
import {useAuditIncidentStore} from "@/stores/auditIncidentStore";
import {mixed, number, object, string} from "yup";
import {Audit, AuditReviewDocument, UploadNarrativeRequest} from "@/audit.types";
import {useFormValidation} from "@/validation";
import {debounce} from "vue-debounce";
import {BInput, BTextarea, BFileInput} from "../Fields";
import {storeToRefs} from "pinia";
import {useConfirmDialog} from "@/composable/useConfirmDialog";

export default /*@__PURE__*/_defineComponent({
  __name: 'AuditDetailsIncidents',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

const {confirm} = useConfirmDialog();

const props = __props;

var updateData = debounce(() => getData(), "15000ms");

const isShowUploadNarrative = ref(false);
const selectedIncindentId = ref(0);
const uploadNarrativeTitle = ref("");
const isConfirmDialog = ref(false);
const canCheckIncidentsVersion = ref(false);
const auditIncidentStore = useAuditIncidentStore();

const {loading} = storeToRefs(auditIncidentStore);

const uploadNarrativeRequest = ref({} as UploadNarrativeRequest);

const showUploadNarrative = (incident) => {
    isShowUploadNarrative.value = true;
    selectedIncindentId.value = incident.id;

    resetValidation();
    uploadNarrativeRequest.value = {} as UploadNarrativeRequest;
    uploadNarrativeRequest.value.id = incident.id;

    uploadNarrativeTitle.value = `Upload Narrative for incident ${incident.incidentNumber}`;
    return false;
};

const columns = reactive<BTableColumn[]>([
    {
        key: "incidentNumber",
        text: "Incident Number",
        sortable: true,
        value: (item) => item["incidentNumber"],
    },
    {
        key: "incidentType",
        text: "Type",
        sortable: true,
        value: (item) => item.type,
    },
    {
        key: "incidentDate",
        text: "Incident/Arrest Date",
        sortable: true,
        value: (item) => item["date"],
    },
    {
        key: "offenses",
        text: "Offense",
        sortable: false,
        value: (item) => item["offenses"],
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["statusName"],
    },
    {
        key: "actions",
        text: "",
        columnClass: ["text-end"],
        class: (item) => ["text-nowrap text-end"],
        sortable: false,
        value: (item) => 2,
    },
]);

const uploadNarrativeSchema = object<UploadNarrativeRequest>({
    id: number().required(),
    file: mixed().required().label("File"),
});

const {handleSubmit, errors, resetValidation} = useFormValidation();
const isShowNarrativeReviewEditor = ref(false);

const showNarrativeReviewEditor = (id: number) => {
    resetValidation();
    review.value = {status: ""} as AuditReviewDocument;
    selectedIncindentId.value = id;
    isShowNarrativeReviewEditor.value = true;
};

const isShowIncidentReviewEditor = ref(false);

const showIncidentReviewEditor = (id: number) => {
    resetValidation();
    selectedIncindentId.value = id;
    review.value = {status: ""} as AuditReviewDocument;
    isShowIncidentReviewEditor.value = true;
};

const reviewIncident = async function () {
    if (await handleSubmit(reviewIncidentSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewIncident(review.value);
        isShowIncidentReviewEditor.value = false;
        await getData();
    }
};

const reviewNarrativeSchema = object<AuditReviewDocument>({});

const reviewIncidentSchema = object<AuditReviewDocument>({
    status: string().required().label("Status"),
});

const review = ref({} as AuditReviewDocument);

const reviewNarrative = async function () {
    if (await handleSubmit(reviewNarrativeSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewNarrative(review.value);
        isShowNarrativeReviewEditor.value = false;
        await getData();
    }
};

const checkIncidentsVersion = async () => {
    await auditIncidentStore.checkIncidentsVersion(props.id);
    await getData();
};

const hideConfirmDialog = async function () {
    isConfirmDialog.value = false;
};
const deleteIncident = async function (id: number) {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        await auditIncidentStore.deleteItem(id);
        await getData();
        await hideConfirmDialog();
    }
};

const getData = async () => {
    await auditIncidentStore.list(props.audit.id);
    await updateData();
};

const uploadDocument = async () => {
    if (await handleSubmit(uploadNarrativeSchema, uploadNarrativeRequest.value)) {
        await auditIncidentStore.uploadNarrative(uploadNarrativeRequest.value);
        await getData();
        isShowUploadNarrative.value = false;
    }
};

const isAuditEditable = computed(() => {
    return props.audit.statusCode != "AC";
});

const redirectToReportViewer = (url:string) => {
    //If we don't set the searchUrl value then NameSearch.aspx will be used
    sessionStorage.setItem("SearchURL", window.location.href.substring(window.location.href.lastIndexOf('/') + 1));
    window.open(url, '_blank');
}

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FormModal), {
      title: "Reject Narrative",
      modelValue: isShowNarrativeReviewEditor.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowNarrativeReviewEditor).value = $event)),
      onSubmit: reviewNarrative,
      loading: _unref(loading),
      submitButton: "Reject"
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "rejectReviewComment",
              class: "form-label"
            }, "Comment", -1)),
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review.value.comment) = $event)),
              id: "rejectReviewComment",
              class: "form-control"
            }, "                    ", 512), [
              [_vModelText, review.value.comment]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_unref(FormModal), {
      title: "Review Incident",
      modelValue: isShowIncidentReviewEditor.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowIncidentReviewEditor).value = $event)),
      onSubmit: reviewIncident,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "reviewStatus",
              class: "form-label"
            }, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "reviewStatus",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((review.value.status) = $event)),
              class: _normalizeClass(["form-select", {'is-invalid': !!_unref(errors).status}])
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("option", { value: "" }, "Select Status", -1),
              _createElementVNode("option", { value: "IF" }, "Reject Incident", -1),
              _createElementVNode("option", { value: "IP" }, "Accept Incident", -1)
            ]))], 2), [
              [_vModelSelect, review.value.status]
            ]),
            (_unref(errors).status)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(errors).status), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "reviewComment",
              class: "form-label"
            }, "Comment", -1)),
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((review.value.comment) = $event)),
              id: "reviewComment",
              class: "form-control"
            }, "                    ", 512), [
              [_vModelText, review.value.comment]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_unref(FormModal), {
      title: uploadNarrativeTitle.value,
      modelValue: isShowUploadNarrative.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isShowUploadNarrative).value = $event)),
      onSubmit: uploadDocument,
      loading: _unref(loading)
    }, {
      default: _withCtx(() => [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_6, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-3" }, [
              _createElementVNode("label", {
                for: "uploadNarrative",
                class: "col-form-label"
              }, "File:")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(BFileInput), {
                modelValue: uploadNarrativeRequest.value.file,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((uploadNarrativeRequest.value.file) = $event)),
                name: "uploadNarrative",
                error: _unref(errors).file
              }, null, 8, ["modelValue", "error"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "loading"]),
    (__props.runAudits)
      ? (_openBlock(), _createBlock(AuditJobs, {
          key: 0,
          "run-audits": __props.runAudits,
          "create-audits": __props.createAudits,
          audit: __props.audit,
          id: __props.id
        }, null, 8, ["run-audits", "create-audits", "audit", "id"]))
      : _createCommentVNode("", true),
    _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Incidents", -1)),
    _createVNode(BGrid, {
      caption: "List of Incidents",
      tableOptions: _unref(auditIncidentStore).tableOptions,
      filterableFields: _unref(auditIncidentStore).filterableFields,
      filterOptions: _unref(auditIncidentStore).filterOptions,
      onOptionChange: getData,
      items: _unref(auditIncidentStore).items,
      columns: columns,
      loading: _unref(auditIncidentStore).loading
    }, _createSlots({
      "cell.incidentNumber": _withCtx(({item, column}) => [
        _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers(($event: any) => (redirectToReportViewer(`MSIVReportViewer.aspx?IncidentNumber=${item.incidentNumber}&ORI=${item.ori}`)), ["prevent"])
        }, _toDisplayString(item.incidentNumber), 9, _hoisted_8)
      ]),
      "cell.status": _withCtx(({item, column}) => [
        _createTextVNode(_toDisplayString(item.statusName) + " ", 1),
        (item.comment)
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "bi bi-info-circle-fill text-info",
              "aria-label": `Status comment: ${item.comment}`,
              role: "img"
            }, null, 8, _hoisted_9)), [
              [_directive_tooltip, item.comment]
            ])
          : (item.narrative && item.narrative.comment)
            ? _withDirectives((_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "bi bi-info-circle-fill text-info",
                "aria-label": `Narrative comment: ${item.narrative.comment}`,
                role: "img"
              }, null, 8, _hoisted_10)), [
                [_directive_tooltip, item.narrative.comment]
              ])
            : _createCommentVNode("", true),
        (!item.loadId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(" Deleted ")
            ], 64))
          : (item.actionLoadId && item.loadId != item.actionLoadId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(" Updated ")
              ], 64))
            : _createCommentVNode("", true)
      ]),
      "cell.actions": _withCtx(({item, column}) => [
        (item.narrative == null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              (isAuditEditable.value && item.status == 'NR' && !__props.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"]),
                    "aria-label": `Upload narrative for incident ${item.incidentNumber}`
                  }, " Upload Narrative ", 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (item.narrative.hasFileContent)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn btn-sm btn-secondary ms-1",
                    href: `api/v1/audit/file/${item.narrative.fileId}`,
                    "aria-label": `View narrative for incident ${item.incidentNumber}`
                  }, "View Narrative", 8, _hoisted_13))
                : _createCommentVNode("", true),
              (isAuditEditable.value && item.narrative.status != 'DA' && !__props.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showUploadNarrative(item)), ["prevent"]),
                    "aria-label": `Replace narrative for incident ${item.incidentNumber}`
                  }, " Replace Narrative ", 8, _hoisted_14))
                : _createCommentVNode("", true)
            ], 64)),
        (__props.runAudits && item.narrative)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (isAuditEditable.value && item.narrative.status == 'DU' && item.status == 'IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-danger btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showNarrativeReviewEditor(item.id)), ["prevent"]),
                    "aria-label": `Reject narrative for incident ${item.incidentNumber}`
                  }, " Reject Narrative ", 8, _hoisted_15))
                : _createCommentVNode("", true),
              (isAuditEditable.value && item.narrative.status == 'DU' && item.status == 'IN')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"]),
                    "aria-label": `Review incident ${item.incidentNumber}`
                  }, " Review Incident ", 8, _hoisted_16))
                : _createCommentVNode("", true),
              (isAuditEditable.value && (item.status == 'IF' || item.status == 'IP'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-sm ms-1",
                    onClick: _withModifiers(($event: any) => (showIncidentReviewEditor(item.id)), ["prevent"]),
                    "aria-label": `Update review for incident ${item.incidentNumber}`
                  }, " Update Review ", 8, _hoisted_17))
                : (_openBlock(), _createElementBlock("span", _hoisted_18))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_19)),
        (__props.runAudits && isAuditEditable.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "btn btn-danger btn-sm ms-1",
              onClick: _withModifiers(($event: any) => (deleteIncident(item.id)), ["prevent"]),
              "aria-label": `Delete request for incident ${item.incidentNumber}`
            }, " Delete Request ", 8, _hoisted_20))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (canCheckIncidentsVersion.value)
        ? {
            name: "beforeFilter",
            fn: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (checkIncidentsVersion()), ["prevent"]))
              }, " Update Incident Versions ")
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["tableOptions", "filterableFields", "filterOptions", "items", "columns", "loading"])
  ]))
}
}

})